import React, { useEffect, useState } from 'react';
import { IonChip, IonItem, IonLabel, IonList, IonNote, IonSegment, IonSegmentButton, IonSpinner } from '@ionic/react';
import { ServiceEstimate } from '../../../interfaces/ServiceEstimate';
import { serviceApi } from '../../../utils/serviceEstimatesApi';
import { STATUS_COLOR, STATUS_LABEL, money, shortDate } from './serviceFormat';
import './SavedEstimates.css';

interface Props {
  onOpen: (e: ServiceEstimate) => void;
  refreshKey: number;
}

const SavedEstimates: React.FC<Props> = ({ onOpen, refreshKey }) => {
  const [scope, setScope] = useState<'mine' | 'team'>('mine');
  const [rows, setRows] = useState<ServiceEstimate[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setRows(null);
    serviceApi.listEstimates(scope).then(setRows).catch((e) => { setError(e instanceof Error ? e.message : 'Could not load estimates.'); setRows([]); });
  }, [scope, refreshKey]);

  return (
    <div className="saved-estimates">
      <IonSegment value={scope} onIonChange={(e) => setScope(e.detail.value as 'mine' | 'team')}>
        <IonSegmentButton value="mine"><IonLabel>My estimates</IonLabel></IonSegmentButton>
        <IonSegmentButton value="team"><IonLabel>Team</IonLabel></IonSegmentButton>
      </IonSegment>
      {rows === null && <IonSpinner />}
      {error && <p className="saved-error">{error}</p>}
      {rows && rows.length === 0 && !error && <p className="saved-empty">No estimates yet. Start one on the Estimate tab.</p>}
      {rows && rows.length > 0 && (
        <IonList inset>
          {rows.map((e) => {
            const key = e.is_expired ? 'expired' : e.status;
            return (
              <IonItem key={e.id} button detail onClick={() => onOpen(e)}>
                <IonLabel>
                  <h3>{e.customer_detail.name}</h3>
                  <p>{shortDate(e.estimate_date)} · {e.prepared_by_name}{e.acs_number ? ` · ${e.acs_number}` : ''}</p>
                </IonLabel>
                <IonChip color={STATUS_COLOR[key]} slot="end">{STATUS_LABEL[key]}</IonChip>
                <IonNote slot="end" className="saved-total">{money(e.total_price)}</IonNote>
              </IonItem>
            );
          })}
        </IonList>
      )}
    </div>
  );
};

export default SavedEstimates;
